<ng-container>
  <span class="overline">School</span>
  <h3 class="mt-2">Address Information</h3>
</ng-container>
<!-- NONE EDIT MODE no Form -->
<ng-container>
  <div class="row" *ngIf="!editModeOff">
    <div class="col">
      <div class="data-list-item my-2">
        <div>
          Address 1
        </div>
        <div>
          <strong class="right-align">{{ schoolData?.address.street1 }}</strong>
        </div>
      </div>
      <app-divider></app-divider>
      <div class="data-list-item my-2">
        <div>
          Address 2
        </div>
        <div>
          <strong class="right-align">{{ schoolData?.address.street2 }}</strong>
        </div>
      </div>
      <app-divider></app-divider>
      <div class="data-list-item my-2">
        <div>
          City
        </div>
        <div>
          <strong class="right-align">{{ schoolData?.address.city }}</strong>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="data-list-item my-2">
        <div>
          State
        </div>
        <div>
          <strong class="right-align">{{ schoolData?.address.state }}</strong>
        </div>
      </div>
      <app-divider></app-divider>
      <div class="data-list-item my-2">
        <div>
          Zip Code
        </div>
        <div>
          <strong class="right-align">{{ schoolData?.address.postalCode }}</strong>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<!-- Edit Mode -->
<div *ngIf="editModeOff" [formGroup]="form">
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>Street 1</mat-label>
        <input matInput type="text" placeholder="Street 1" formControlName="street1" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Street 2</mat-label>
        <input matInput type="text" placeholder="Street 2" formControlName="street2" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>City</mat-label>
        <input matInput type="text" placeholder="City" formControlName="city" />
      </mat-form-field>
    </div>
    <div class="col">
      <mat-form-field>
        <mat-label>State</mat-label>
        <mat-select data-cy="schoolAddressStateSelect" formControlName="state" ngDefaultControl>
          <mat-option *ngFor="let st of states$ | async" [value]="st.abbreviation">
            {{ st.abbreviation }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Zip Code</mat-label>
        <input matInput type="text" placeholder="Zip Code" formControlName="postalCode" />
      </mat-form-field>
    </div>
  </div>
</div>

<div class="row pad-bot-10">
  <div class="col d-flex justify-content-start">
    <button
      mat-stroked-button
      color="accent"
      data-cy="lender-demographics-edit-button"
      (click)="editForm()"
      *ngIf="!editModeOff"
      [disabled]="wrongUser"
    >
      Edit
    </button>
    <button mat-raised-button color="primary" (click)="cancelEdit()" *ngIf="editModeOff" class="margin-right-10">
      Cancel Edit
    </button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      *ngIf="editModeOff"
      [disabled]="form.pristine || form.invalid"
      class="margin-right-10"
      (click)="submit()"
    >
      Save Changes
    </button>
    <button mat-stroked-button color="accent" *ngIf="editModeOff" [disabled]="form.pristine" (click)="revertForm()">
      Revert Changes
    </button>
  </div>
</div>
